// Optional context for rendering an "artifact preview card" — the compact
// inline preview that the chat shows under tool-write parts when the
// resulting file is one of our previewable kinds (pptx/xlsx/pdf/docx/csv/
// md/html). The actual implementation lives in the host app
// (packages/app/src/components/artifact-preview-card.tsx) because it needs
// access to the SDK, the file-loading context, and FilePreview. The
// upstream message-part.tsx in this package only needs the slot.
//
// Optional context (returns undefined when no provider is mounted) so this
// shared library still works in tooling that doesn't wire up the host
// app — Storybook, tests, the docs site, etc.
import { createContext, useContext, type ParentProps, type ValidComponent } from "solid-js"

export type ArtifactPreviewProps = {
  path: string
}

export type ArtifactPreviewComponent = ValidComponent

const ctx = createContext<ArtifactPreviewComponent | undefined>(undefined)

export function ArtifactPreviewProvider(props: ParentProps<{ component: ArtifactPreviewComponent }>) {
  return <ctx.Provider value={props.component}>{props.children}</ctx.Provider>
}

export function useArtifactPreview(): ArtifactPreviewComponent | undefined {
  return useContext(ctx)
}
